<app-verify-with-otp [useContextContact]="true" #verifyOtpComponent
                     [requestOtpEndpoint]="requestEndpoint"
                     requestEndpointType="get"
                     [requestOtpBody]="requestBody"
                     [errMessage]="errMessage"
                     pageHeader="Please verify changes to your banking details"
                     (otpVerified)="onVerify($event)"
></app-verify-with-otp>

